import React from 'react';
import {Col, Container, Row, Accordion} from "react-bootstrap";

function Question(props) {
    return (
        <div className={props.color ? 'services_question bg_color p-100' : 'services_question p-100'}>
            <Container>
                <Row>
                    <Col xs={12} md={12} lg={8} xl={8} xxl={8} className="question_title">
                        <div className="example" data-text="FAQs">
                            <h2>Frequently Asked Questions</h2>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="services_faqs">
                        <Accordion defaultActiveKey="0">
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>
                                    What is the Google Cloud service?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>Google Cloud Platform (GCP), provided by Google, is a collection of cloud computing services hosted on the very infrastructure employed by Google for its consumer-facing products like Google Search, Gmail, Google Drive, and YouTube.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>
                                    What are types of services in Google Cloud?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>Here are the seven services offered by Google Cloud:</p>
                                    <ul>
                                        <li>Compute</li>
                                        <li>Networking</li>
                                        <li>Storage and Databases</li>
                                        <li>Big Data</li>
                                        <li>Machine Learning</li>
                                        <li>Identity & Security</li>
                                        <li>Management and Developer Tools</li>
                                    </ul>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Question;